import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { verify_otp_v2 } from "./apiservices/ApiService";
import { saveUserData } from "./common/Utils";

import GOQiiPlayScreen from "./ui/play/GOQiiPlayScreen";
import GOQiiCashScreen from "./ui/goqii-cash/GOQiiCashScreen";
import ProductDetailPage from "./store/ProductDetailPage";
import StoreHomePage from "./store/StoreHomePage";
import ShoppingCartPage from "./store/ShoppingCartPage";
import StoreCategoryGridPage from "./store/StoreCategoryGridPage";
import OrdersDetailPage from "./store/OrdersDetailPage";

import CoachChatScreen from "./screen/fsn2/Fsn2CoachChat";
import Dashboard from "./ui/home/Dashboard";
import FlashFlicks from "./reel/FlashFlicks";
import CoachConsultationUI from "./ui/coach/CoachConsultationUI";
import GoalsAndHabits from "./ui/settings/GoalsAndHabits";
import Fsn2CoachChat from "./screen/fsn2/Fsn2CoachChat";
import fsnRoutes from "./navigation/FsnRoutes";
import Fsn117HealthyReads from "./screen/Fsn117HealthyReads";
import Fsn0DefaultScreen from "./screen/Fsn0DefaultScreen";
import Fsn11DoctorConsultation from "./screen/fsn11/Fsn11DoctorConsultation";
import Fsn8DoctorTimeSlotBooking from "./screen/fsn11/Fsn8DoctorTimeSlotBooking";
import AddressList from "./store/AddressList";

import HomeScreen from "./HomeScreen";

import UnlockScreen from "./reel/UnlockScreen";
import LoadingProgressBar from "./common/LoadingProgressBar";
import IframeScreen from "./IframeScreen";
import HomeScreenTemp from "./HomeScreenTemp";
import GOQiiAppHomeScreen from "./GOQiiAppHomeScreen";



const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

function App() {
  const query = useQuery();
  const screen = query.get("screen");
  const encUserId = query.get("encUserId");
  const jwtToken = query.get("jwtToken");

  const [apiSuccess, setApiSuccess] = useState(true); // null -> loading, true -> success, false -> error
  const navigate = useNavigate();

  // API call before loading UI
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (encUserId && jwtToken) {
          const response = await verify_otp_v2({ encUserId, jwtToken });
          console.log("API Response verify_otp_v2:", response);
          if (response) {
            saveUserData(response);
            setApiSuccess(true);
          } else {
            console.error("API Error:", response);
            setApiSuccess(false);
          }
        } else {
          setApiSuccess(true); // If no encUserId/jwtToken, proceed normally
        }
      } catch (err) {
        console.error("Network Error:", err);
        setApiSuccess(false);
      }
    };

    fetchData();
  }, [encUserId, jwtToken]);

  const hideAddressSelection = () => {
    handleBackButtonPress();
  };

  const handleBackButtonPress = () => {
    navigate(-1);
  };

  // Show loader while API is pending
  if (apiSuccess === null) {
    return <LoadingProgressBar/>; // Loader ya kuch bhi dikhana
  }

  // Show error screen if API fails
  if (apiSuccess === false) {
    return <Fsn0DefaultScreen />;
  }

  // After API success, render normal flow
  const renderScreen = () => {
    switch (screen) {

      case "temp_pwa_luanch":
        return <HomeScreenTemp />;

      case "pwa_luanch":
        return <HomeScreen />;

      case "TimeSlotBooking":
        return <Fsn8DoctorTimeSlotBooking />;
      case "coaching":
        return <Fsn2CoachChat />;
      case "doctor":
        return <Fsn11DoctorConsultation />;
      case "healthyreads":
        return <Fsn117HealthyReads />;
      case "playscreen":
        return <GOQiiPlayScreen />;
      case "goqiicash":
        return <GOQiiCashScreen />;
      case "homescreen":
        return <Dashboard />;
      case "flashflicks":
        return <FlashFlicks />;
      case "store_home_page":
        return <StoreHomePage />;
      default:
        return <LoadingProgressBar />;
    }
  };

  return (
    <Routes>

      <Route path="/iframe_screen" element={<IframeScreen />} />


      <Route path="/pwa_luanch" element={<HomeScreen />} />

      <Route path="/goqii_pwa_luanch" element={<GOQiiAppHomeScreen />} />
      <Route path="/temp_pwa_luanch" element={<HomeScreenTemp />} />
      

      <Route path="/" element={renderScreen()} />
      <Route path="/unlock" element={<UnlockScreen />} />
      <Route path="/product_detail_page" element={<ProductDetailPage />} />
      <Route path="/store_home_page" element={<StoreHomePage />} />
      <Route path="/store_cart_page" element={<ShoppingCartPage />} />
      <Route
        path="/address"
        element={
          <AddressList
            onAddressSelect={hideAddressSelection}
            defaultShowAddAddress={false}
          />
        }
      />
      <Route path="/store_category_grid_page" element={<StoreCategoryGridPage />} />
      <Route path="/store_order_details" element={<OrdersDetailPage />} />
      <Route path="/coach" element={<CoachConsultationUI />} />
      <Route path="/doctor-consultation" element={<Fsn11DoctorConsultation />} />
      <Route path="/coach-chat" element={<CoachChatScreen />} />
      <Route path="/play-screen" element={<GOQiiPlayScreen />} />
      <Route path="/goals_and_habits" element={<GoalsAndHabits />} />

      {fsnRoutes.map(({ route, element }, index) => (
        <Route key={index} path={route} element={element} />
      ))}
    </Routes>
  );
}

export default App;